import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../../Tooltip'

const Letter = props => {
  const ref = useRef()
  return (
    <div ref={ref} className={props.className} style={props.style} onClick={props.onClick}>
      {props.letter}
      <Tooltip
        position={'up-left'}
        onTarget={() => ref.current}
        content={props.tooltip}
        showOn={'mouseenter'}
        hideOn={'click&propagate click:body wheel:body scroll:body mouseleave'}
      />
    </div>
  )
}

Letter.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  letter: PropTypes.string,
  tooltip: PropTypes.any,
  onClick: PropTypes.func
}

export default Letter
